<template>
  <p id="ICP">广州奇点网络信息有限公司 <a href="http://www.beian.miit.gov.cn/">粤ICP备18089782号</a></p>
</template>

<script>
export default {
  name: 'ICP'
}
</script>

<style lang="scss">
@import "@/assets/scss/constant.scss";
#ICP {
  position: absolute;
  bottom: 10px;
  width: $clientWidth;
  color: #999;
  font-size: 20px;
  text-align: center;
  a {
    color: #999;
    font-size: 20px;
    text-decoration: underline;
  }
  &.account-ICP {
    position: relative;
    margin-top: 60px;
    bottom: 10px;
  }
}
</style>